import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import decryptData from '../../helpers/Decryption';

const BranchDetail = () => {
    const [data, setData] = useState();
    const [childBranches, setChildBranches] = useState([]);
    const { state } = useLocation();
    const navigate = useNavigate();
    const { getToken } = useAuth();

    useEffect(() => {
        // Persist state to local storage if available
        if (state) {
            localStorage.setItem('branchDetailState', JSON.stringify(state));
        }
    }, [state]);

    useEffect(() => {
        // Retrieve state from local storage if not available in useLocation
        const savedState = localStorage.getItem('branchDetailState');
        const parsedState = savedState ? JSON.parse(savedState) : null;

        if (state?.branch_id && state?.branch_detail) {
            setData(state.branch_detail);
        } else if (parsedState?.branch_id && parsedState?.branch_detail) {
            setData(parsedState.branch_detail);
        }
    }, [state]);

    useEffect(() => {
        // Fetch child branches if branch id is available
        const fetchChildBranches = async (branchId) => {
            const token = getToken();
            if (token && branchId) {
                const res = await new WebApiCalls().getAllBranches(token, 1000, 0, '', '');
                if (res?.code === 200) {
                    const decryptedData = await decryptData(res?.data);
                    const children = decryptedData.filter((b) => b.parent?._id === branchId);
                    setChildBranches(children);
                }
            }
        };

        // Retrieve state from local storage if not available in useLocation
        const savedState = localStorage.getItem('branchDetailState');
        const parsedState = savedState ? JSON.parse(savedState) : null;

        if (state?.branch_id && state?.branch_detail) {
            setData(state.branch_detail);
            fetchChildBranches(state.branch_id);
        } else if (parsedState?.branch_id && parsedState?.branch_detail) {
            setData(parsedState.branch_detail);
            fetchChildBranches(parsedState.branch_id);
        }
    }, [state, getToken]);

    useEffect(() => {
        return () => {
            // Clear local storage state when navigating away
            localStorage.removeItem('branchDetailState');
        };
    }, []);

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={3} className="text-center">
                    <div>
                        <Button
                            onClick={() =>
                                navigate(state.redirect_url, {
                                    state: {
                                        branch_id: state.branch_id,
                                        branch_detail: state.branch_detail
                                    }
                                })
                            }
                            className="theme-cancel-btn px-5 py-2"
                        >
                            Close
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3">
                    <Row>
                        <Col md={3}>
                            <div className="detail-small-heading">Name</div>
                            <div className="detail-value">{data?.name}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Address</div>
                            <div className="detail-value">{data?.address}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Latitude</div>
                            <div className="detail-value">{data?.lat}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Longitude</div>
                            <div className="detail-value">{data?.lng}</div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={3}>
                            <div className="detail-small-heading">Vendor Name</div>
                            <div className="detail-value">{data?.vendor?.name}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Vendor Email</div>
                            <div className="detail-value" style={{ textTransform: 'none' }}>
                                {data?.vendor?.email}
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Vendor Phone</div>
                            <div className="detail-value">{data?.vendor?.phone_no}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Vendor Website</div>
                            <div className="detail-value" style={{ textTransform: 'none' }}>
                                <a href={data?.vendor?.vendor_website} target="_blank" rel="noopener noreferrer">
                                    {data?.vendor?.vendor_website}
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={3}>
                            <div className="detail-small-heading">Vendor Status</div>
                            <div className="detail-value">{data?.vendor?.status}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Created At</div>
                            <div className="detail-value">{new Date(data?.createdAt).toLocaleDateString()}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Parent Branch</div>
                            <div className="detail-value">{data?.parent?.name || 'None'}</div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={12}>
                            <div className="detail-small-heading">Child Branches</div>
                            <div className="detail-value">
                                {childBranches.length > 0 ? (
                                    <table className="table table-bordered detail-value" style={{ width: 'auto' }}>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {childBranches.map((child) => (
                                                <tr key={child._id}>
                                                    <td>{child.name}</td>
                                                    <td>{child.address}</td>
                                                    <td>{child.status}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    'None'
                                )}
                            </div>
                        </Col>
                    </Row>
                    <hr className="mt-5" />
                    {/* <Row className="mt-5">
                        <Col md={4}>
                            <div className="detail-value mb-4">Offers Listing</div>
                        </Col>
                    </Row>
                    <Row>
                        <Offers branchId={state.branch_id} branchDetails={state.branch_detail} redirectUrl={'/branches/branch-details'} />
                    </Row> */}
                </Col>
            </Row>
        </>
    );
};

export default BranchDetail;
